
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wl",
      function () {
        return require("private-next-pages/wl.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wl"])
      });
    }
  